export const PRIVACY_POLICY = "https://unibuddy.com/privacy-policy/";
export const TERMS_OF_USE = "https://unibuddy.com/terms-of-use/";
export const ACCEPTABLE_USE_POLICY = "https://unibuddy.com/acceptable-use-policy/";
export const COOKIE_POLICY = "https://unibuddy.com/cookie-policy/";
export const LIST_OF_SUB_PROCESSORS = "https://unibuddy.com/sub-processors/";
export const UNIBUDDY_HELP_CENTER =
    "https://help.unibuddy.co/en/collections/2439629-i-am-a-prospect-applicant";
